import type {HttpErrorType, ProblemConstraintViolation} from 'api/http/types';

export const transformErrorResponse = (
  response: {
    data?: ProblemConstraintViolation;
    status: number;
  },
  meta: {request: Request; response?: Response},
): HttpErrorType => {
  return {
    status: response.status,
    url: meta.request.url,
    message:
      response?.data?.title ??
      `HTTP ${meta.request.method} failed: status: ${response.status}`,
    info: response?.data,
  };
};
